// src/pages/Dashboard.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from '../components/dashboard/Sidebar';
import DashboardHeader from '../components/dashboard/DashboardHeader';
import StorageCard from '../components/dashboard/StorageCard';
import InheritanceCard from '../components/dashboard/InheritanceCard';
import FilesPieChartCard from '../components/dashboard/FilesPieChartCard';
import DistributionPieChartCard from '../components/dashboard/DistributionPieChartCard';
import { getMaxStorageSize, getUsedPercentage } from '../utils/storage.utils';
import StorageOverviewCard from '../components/dashboard/StorageOverviewCard';
import '../styles/pages/dashboard.css';

const Dashboard = () => {
  const { user } = useAuth();
  const [sidebarToggled, setSidebarToggled] = useState(false);

  // Maximum storage based on subscription
  const maxStorageSize = user ? getMaxStorageSize(user.SubscriptionType) : 1024 * 1024 * 1024;

  useEffect(() => {
    return () => {
      document.body.classList.remove('sidebar-open');
    };
  }, []);

  const toggleSidebar = () => {
    const newSidebarState = !sidebarToggled;
    setSidebarToggled(newSidebarState);

    // For mobile, handle body class for layout control
    if (window.innerWidth <= 768) {
      if (newSidebarState) {
        document.body.classList.remove('sidebar-open');
      } else {
        document.body.classList.add('sidebar-open');
      }
    }
  };

  // Check if user should see inheritance card based on subscription
  const showInheritanceCard = () => {
    return user && user.SubscriptionType !== "1" && user.SubscriptionType !== "3";
  };

  return (
    <div id="page-top">
      <div id="wrapper" className="d-flex">
        <Sidebar toggled={sidebarToggled} setToggled={setSidebarToggled} />

        <div
          id="content-wrapper"
          className={`d-flex flex-column ${sidebarToggled ? 'content-toggled' : ''}`}
        >
          <div id="content">
            <DashboardHeader
              toggleSidebar={toggleSidebar}
              className="dashboard-header"
            />

            <div className="container-fluid px-3 py-3">
              {/* Storage Overview Row */}
              <div className="row mb-3">
                <StorageOverviewCard maxSize={maxStorageSize} />
              </div>

              {/* Storage Cards - Pure CSS Grid (no Bootstrap grid) */}
              <div className="storage-cards-grid mb-3">
                <StorageCard type="files" maxSize={maxStorageSize} />
                <StorageCard type="passwords" maxSize={maxStorageSize} />
                <StorageCard type="banking" maxSize={maxStorageSize} />
                <StorageCard type="blockchain" maxSize={maxStorageSize} />
              </div>

              {showInheritanceCard() && (
                <div className="row mb-3">
                  <InheritanceCard />
                </div>
              )}

              <div className="row g-3 mb-3">
                <div className="col-md-5">
                  <FilesPieChartCard maxSize={maxStorageSize} />
                </div>
                <div className="col-md-6">
                  <DistributionPieChartCard />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
    </div>
  );
};

export default Dashboard;